import { IonButton, IonContent, IonPage } from "@ionic/react";
import AnimationContainer from "../components/Animation";
interface Props {
  onDismiss: (confirm: boolean) => () => void;
  title: string;
  contentHtml: string;
  lottieAnimation?: any;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmationPage: React.FC<Props> = ({
  onDismiss,
  title,
  contentHtml,
  lottieAnimation,
  confirmText,
  cancelText
}) => {
  return (
    <IonPage>
      <IonContent fullscreen className="content-transparent">
        <div className="flex flex-col h-full justify-center items-center">
          <AnimationContainer
            animationName={lottieAnimation || "botCongratsAnimation"}
          />
          <div className="font-semibold text-2xl my-2 text-white text-center px-8">
            {title}
          </div>
          <div dangerouslySetInnerHTML={{ __html: contentHtml }} />
          <IonButton
            color="primary"
            className="w-2/3 font-normal text-lg"
            onClick={() => onDismiss(true)}
          >
            {confirmText || "Confirm"}
          </IonButton>
          <IonButton fill="clear" onClick={() => onDismiss(false)}>
            <span className="text-primary-40 text-small">
              {cancelText || "Cancel"}
            </span>
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ConfirmationPage;
